/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function () {
  var cartUpdating = false;

  function refreshCart() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );
  }

  function showInventoryError() {
    var isJapanese =
      (document.documentElement.lang || '').toLowerCase().indexOf('ja') === 0;

    if (isJapanese) {
      alert(
        '購入可能数を超えています。\nこの商品はこれ以上カートに追加できません。'
      );
    } else {
      alert(
        'The requested quantity exceeds the available stock.\nYou cannot add any more of this item to your cart.'
      );
    }
  }

  function changeCartQuantity(line, quantity) {
    if (cartUpdating) {
      return;
    }

    cartUpdating = true;

    var changeUrl =
      window.routes && window.routes.cartChangeUrl
        ? window.routes.cartChangeUrl
        : '/cart/change';

    if (changeUrl.slice(-3) !== '.js') {
      changeUrl += '.js';
    }

    fetch(changeUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        line: parseInt(line, 10),
        quantity: parseInt(quantity, 10)
      })
    })
      .then(function (response) {
        return response.json().then(function (content) {
          return {
            response: response,
            content: content
          };
        });
      })
      .then(function (result) {
        if (!result.response.ok) {
          showInventoryError();
          refreshCart();
          return;
        }

        refreshCart();
      })
      .catch(function () {
        var isJapanese =
          (document.documentElement.lang || '')
            .toLowerCase()
            .indexOf('ja') === 0;

        alert(
          isJapanese
            ? 'カートの更新に失敗しました。もう一度お試しください。'
            : 'Unable to update your cart. Please try again.'
        );

        refreshCart();
      })
      .then(function () {
        cartUpdating = false;
      });
  }

  /*
   * カート内の ＋ / − ボタン
   */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target.closest
        ? event.target.closest('[data-action="update-item-quantity"]')
        : null;

      if (!target) {
        return;
      }

      var line = target.getAttribute('data-line');
      var quantity = target.getAttribute('data-quantity');

      if (line === null || quantity === null) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      changeCartQuantity(line, quantity);
    },
    true
  );

  /*
   * 数量を直接入力した場合
   */
  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;

      if (
        !target.matches ||
        !target.matches('.QuantitySelector__CurrentQuantity')
      ) {
        return;
      }

      var line = target.getAttribute('data-line');

      if (!line) {
        return;
      }

      var quantity = Math.max(parseInt(target.value, 10) || 1, 1);

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      changeCartQuantity(line, quantity);
    },
    true
  );
})();
/* =========================================
   TOHGORO
   商品ページ：在庫数を超える数量選択・カート追加を防止
========================================= */

(function () {

  function isJapanese() {
    return (document.documentElement.lang || '')
      .toLowerCase()
      .indexOf('ja') === 0;
  }


  function showInventoryMessage(remaining) {

    var message;

    if (isJapanese()) {

      if (remaining <= 0) {
        message =
          '購入可能数を超えています。\n' +
          'この商品の購入可能な数量は、すでにカートに入っています。';

      } else if (remaining === 1) {
        message =
          '購入可能数を超えています。\n' +
          'この商品は現在1点のみご購入いただけます。';

      } else {
        message =
          '購入可能数を超えています。\n' +
          'この商品は現在' + remaining + '点までご購入いただけます。';
      }

    } else {

      if (remaining <= 0) {
        message =
          'You have reached the maximum available quantity for this item.\n' +
          'The available quantity is already in your cart.';

      } else if (remaining === 1) {
        message =
          'The requested quantity exceeds the available stock.\n' +
          'Only 1 item is currently available.';

      } else {
        message =
          'The requested quantity exceeds the available stock.\n' +
          'Up to ' + remaining + ' items are currently available.';
      }

    }

    alert(message);
  }

function findInventoryInfo(variantId) {

  var inventoryInfo = null;

  document
    .querySelectorAll('script[data-tohgoro-inventory-json]')
    .forEach(function (script) {

      if (inventoryInfo) {
        return;
      }

      try {

        var inventories = JSON.parse(script.textContent);

        if (
          Object.prototype.hasOwnProperty.call(
            inventories,
            String(variantId)
          )
        ) {
          inventoryInfo =
            inventories[String(variantId)];
        }

      } catch (error) {

        console.warn(
          'TOHGORO inventory data error:',
          error
        );

      }

    });

  return inventoryInfo;
}

  function findProductData(trigger) {

    var root =
      trigger.closest('.ProductForm') ||
      trigger.closest('[data-section-type="product"]') ||
      trigger.closest('section') ||
      document;

    var form =
      trigger.closest('form') ||
      root.querySelector('form[action*="/cart/add"]');

    var variantInput =
      (form && form.querySelector('[name="id"]')) ||
      root.querySelector('[name="id"]');

    var quantityInput =
      (form && form.querySelector('[name="quantity"]')) ||
      root.querySelector('[name="quantity"]');

    if (!variantInput) {
      return null;
    }

    return {
      form: form,
      root: root,
      variantId: String(variantInput.value),
      quantityInput: quantityInput
    };
  }


  function getCartQuantity(variantId) {

    var cartUrl =
      window.routes && window.routes.cartUrl
        ? window.routes.cartUrl + '.js'
        : '/cart.js';

    return fetch(cartUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {

        return cart.items.reduce(function (total, item) {

          if (String(item.variant_id) === String(variantId)) {
            return total + Number(item.quantity);
          }

          return total;

        }, 0);

      });
  }


  document.addEventListener(
    'click',
    function (event) {

      var increaseButton = event.target.closest
        ? event.target.closest('[data-action="increase-quantity"]')
        : null;

      var addButton = event.target.closest
        ? event.target.closest('[data-action="add-to-cart"]')
        : null;


      /*
       * 在庫確認済みの「カートに追加」は
       * 2回目だけPrestige本来の処理へ通す
       */
      if (
        addButton &&
        addButton.dataset.tohgoroInventoryApproved === 'true'
      ) {
        delete addButton.dataset.tohgoroInventoryApproved;
        return;
      }


      if (!increaseButton && !addButton) {
        return;
      }


      var trigger = increaseButton || addButton;
      var productData = findProductData(trigger);

      if (!productData) {
        return;
      }


      var inventoryInfo =
        findInventoryInfo(productData.variantId);

      /*
       * 在庫情報が取得できない商品は
       * Prestige本来の処理に任せる
       */
      if (!inventoryInfo) {
        return;
      }


      /*
       * Shopifyで在庫管理していない商品、
       * 在庫切れでも販売を続ける商品は対象外
       */
      if (
        !inventoryInfo.inventory_management ||
        inventoryInfo.inventory_policy === 'continue'
      ) {
        return;
      }


      var inventoryQuantity =
        Number(inventoryInfo.inventory_quantity);

      if (!Number.isFinite(inventoryQuantity)) {
        return;
      }


      /*
       * ここから先はPrestigeの処理を一旦止める
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      /*
       * 連打防止
       */
      if (trigger.dataset.tohgoroChecking === 'true') {
        return;
      }

      trigger.dataset.tohgoroChecking = 'true';


      getCartQuantity(productData.variantId)
        .then(function (quantityInCart) {

          var remaining =
            Math.max(
              inventoryQuantity - quantityInCart,
              0
            );


          /* -------------------------
             商品ページの「＋」
          ------------------------- */

          if (increaseButton) {

            var currentQuantity =
              productData.quantityInput
                ? parseInt(
                    productData.quantityInput.value,
                    10
                  ) || 1
                : 1;

            var nextQuantity =
              currentQuantity + 1;


            if (nextQuantity > remaining) {

              showInventoryMessage(remaining);
              return;
            }


            if (productData.quantityInput) {
              productData.quantityInput.value =
                nextQuantity;
            }

            return;
          }


          /* -------------------------
             「カートに追加」
          ------------------------- */

          if (addButton) {

            var requestedQuantity =
              productData.quantityInput
                ? parseInt(
                    productData.quantityInput.value,
                    10
                  ) || 1
                : 1;


            if (
              requestedQuantity > remaining ||
              remaining <= 0
            ) {

              showInventoryMessage(remaining);
              return;
            }


            /*
             * 在庫内ならPrestige本来の
             * カート追加処理を実行
             */
            addButton.dataset.tohgoroInventoryApproved =
              'true';

            addButton.click();
          }

        })
        .catch(function (error) {

          console.warn(
            'TOHGORO inventory check:',
            error
          );

        })
        .finally(function () {

          delete trigger.dataset.tohgoroChecking;

        });

    },
    true
  );

})();
/* =========================================
   TOHGORO - Packing instructions to order note
========================================= */

(function () {

  function getCheckedValue(form, name) {
    var checked = form.querySelector(
      '[name="attributes[' + name + ']"]:checked'
    );

    return checked ? checked.value : '';
  }


  function getFieldValue(form, name) {
    var field = form.querySelector(
      '[name="attributes[' + name + ']"]'
    );

    return field ? field.value.trim() : '';
  }


  function translateValue(type, value) {

    if (type === 'gift') {
      if (value === 'Required') return '希望する';
      if (value === 'Not required') return '不要';
    }

    if (type === 'bag') {
      if (value === 'Required') return '必要';
      if (value === 'Not required') return '不要';
    }

    if (type === 'noshi') {
      if (value === 'Required') return '希望する';
      if (value === 'Not required') return '不要';
    }

    if (type === 'wrapping') {
      if (value === 'Together') return 'まとめて包装';
      if (value === 'Individually') return '個別に包装';
    }

    return value;
  }


  document.addEventListener(
    'submit',
    function (event) {

      var form = event.target;

      if (
        !(form instanceof HTMLFormElement) ||
        !form.classList.contains('Cart')
      ) {
        return;
      }


      /*
       * 「購入手続きへ」の時だけ処理
       */
      var submitter =
        event.submitter || document.activeElement;

      if (
        !submitter ||
        submitter.getAttribute('name') !== 'checkout'
      ) {
        return;
      }


      var noteField =
        form.querySelector('[name="note"]');

      if (!noteField) {
        return;
      }


      var gift =
        getCheckedValue(form, 'Gift Wrapping');

      var wrapping =
        getCheckedValue(form, 'Wrapping Method');

      var bag =
        getCheckedValue(form, 'Shopping Bag');

      var noshi =
        getCheckedValue(form, 'Noshi');

      var noshiInscription =
        getFieldValue(form, 'Noshi Inscription');

      var noshiName =
        getFieldValue(form, 'Noshi Name');

      var delivery =
        getFieldValue(form, 'Delivery Request');


      /*
       * 現在のお客様メモを取得
       *
       * 以前生成した梱包指示が入っている場合は
       * 「その他のご要望」部分だけ取り出す
       */
      var customerNote =
        noteField.value.trim();

      var previousMarker = '【その他のご要望】';

      if (
        customerNote.indexOf('【梱包・配送指示】') === 0
      ) {

        var markerPosition =
          customerNote.indexOf(previousMarker);

        if (markerPosition !== -1) {
          customerNote =
            customerNote
              .substring(
                markerPosition +
                previousMarker.length
              )
              .trim();
        } else {
          customerNote = '';
        }
      }


      var lines = [];

      lines.push('【梱包・配送指示】');
      lines.push('');

      lines.push(
        'ギフト包装：' +
        translateValue('gift', gift || 'Not required')
      );


      if (gift === 'Required') {

        lines.push(
          '包装方法：' +
          (
            translateValue(
              'wrapping',
              wrapping
            ) || '未指定'
          )
        );

      }


      lines.push(
        '紙袋：' +
        translateValue(
          'bag',
          bag || 'Not required'
        )
      );


      lines.push(
        '熨斗：' +
        translateValue(
          'noshi',
          noshi || 'Not required'
        )
      );


      if (noshi === 'Required') {

        lines.push(
          '表書き：' +
          (noshiInscription || '未指定')
        );

        lines.push(
          'お名前：' +
          (noshiName || '空欄')
        );

      }


      lines.push(
        '配送希望：' +
        (delivery || 'なし')
      );


      lines.push('');
      lines.push('【その他のご要望】');

      lines.push(
        customerNote || 'なし'
      );


      noteField.value =
        lines.join('\n');

    },
    true
  );


  /*
   * チェックアウトからカートへ戻った場合、
   * お客様には生成済みの梱包指示を見せず、
   * 元の自由記入内容だけ表示する
   */
  document.addEventListener(
    'DOMContentLoaded',
    function () {

      var noteField =
        document.querySelector(
          'form.Cart [name="note"]'
        );

      if (!noteField) return;


      var value =
        noteField.value.trim();

      if (
        value.indexOf('【梱包・配送指示】') !== 0
      ) {
        return;
      }


      var marker =
        '【その他のご要望】';

      var position =
        value.indexOf(marker);

      if (position !== -1) {

        var originalNote =
          value
            .substring(
              position + marker.length
            )
            .trim();

        if (originalNote === 'なし') {
          originalNote = '';
        }

        noteField.value =
          originalNote;

      }

    }
  );

})();
/* =========================================================
   言語切替時に国・通貨も同時に変更
   日本語 → Japan / JPY
   English → United States / USD
========================================================= */

document.addEventListener(
  'click',
  function (event) {

    var button = event.target.closest(
      'button[name="locale_code"]'
    );

    if (!button) return;

    var language = button.value;

    if (language !== 'en' && language !== 'ja') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var country =
      language === 'en' ? 'US' : 'JP';

    var form =
      document.createElement('form');

    form.method = 'POST';
    form.action = '/localization';
    form.style.display = 'none';

    var fields = {
      '_method': 'PUT',
      'country_code': country,
      'language_code': language,
      'return_to':
        window.location.pathname +
        window.location.search
    };

    Object.keys(fields).forEach(
      function (name) {

        var input =
          document.createElement('input');

        input.type = 'hidden';
        input.name = name;
        input.value = fields[name];

        form.appendChild(input);
      }
    );

    document.body.appendChild(form);
    form.submit();

  },
  true
);